import React, { Component } from 'react';
import autobind from 'react-autobind';
import { Navbar, Nav, NavItem } from 'reactstrap';
import { DropdownItem } from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { NavLink as RouterLink, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { animateScroll } from 'react-scroll';
import Menu from 'ui/common/menu';
import { show as showModal } from 'redux-modal';

import MediaQuery from 'react-responsive';
import themeConfig from 'ui/theme/config';
import classnames from 'classnames';
import styles from './index.module.scss';
import routeGenerator from 'ui/common/routes/generators';

import Avatar from 'ui/users/avatar';
import AdminNavItems from './admin';
import Icon from 'ui/common/icon';
import Companies from './companies';

import Button from 'ui/common/button';
import OverflowMenu from 'ui/common/rebranding/components/OverflowMenu/OverflowMenu';
import OverflowMenuItem from 'ui/common/rebranding/components/OverflowMenuItem/OverflowMenuItem';
import OverflowMenuHeader from 'ui/common/rebranding/components/OverflowMenu/OverflowMenuHeader';
import OverflowMenuBottom from 'ui/common/rebranding/components/OverflowMenu/OverflowMenuBottom';

import tribePNG from 'resources/common/tribe-acad-student.png';

import {
  selectIsLoggedIn,
  selectCurrentUser,
  selectCurrentUserFetchedAtleastOnce,
  selectCurrentUserHasPassword,
  selectIsCurrentUserAdmin,
  selectIsCurrentUserFullAccess,
  selectIsCurrentUserNoAccess,
  selectCurrentUserEthereumAddress,
  selectIsCurrentUserEthereumAddressVerified,
  selectIsCurrentUserTier3,
} from 'store/features/auth/selectors';
import {
  selectIsCurrentUsersClaimById,
  selectCanCurrentUserVoteOnClaimById,
} from 'store/features/claims/selectors';
import { logout } from 'store/features/auth/actions';
import ThinkificSSO from './thinkific-sso';

import UpdateBasicInfo, { MODAL_NAME as UPDATE_BASIC_INFO_MODAL } from 'ui/graphql/UpdateBasicInfo';
import EditSocialLinks, { MODAL_NAME as UPDATE_SOCIAL_LINK } from 'ui/graphql/UpdateSocialLinks';
import routeTemplates from 'ui/common/routes/templates';
import { createMatchSelector } from 'ui/common/routes/selectors';

import { AIPValidationEnabled, ImpressAIValidationEnabled } from 'resources/validations';

const scroll = animateScroll;

const navLinkOptions = {
  activeClass: 'active',
  delay: 100,
  spy: true,
  smooth: true,
  duration: 1500,
  offset: -100,
};

class Header extends Component {
  static propTypes = {
    intl: intlShape,
  };

  constructor(props) {
    super(props);

    autobind(this);

    this.navbar = null;
    this.state = {
      navLinkOptions,
      openSubMenu: false,
    };
  }

  toggleSubMenu() {
    this.setState({
      openSubMenu: !this.state.openSubMenu,
    });
  }

  scrollToTop() {
    scroll.scrollToTop();
  }

  showBasicInfoModal() {
    this.props.showModal(UPDATE_BASIC_INFO_MODAL);
  }

  showSocialLinkModal() {
    this.props.showModal(UPDATE_SOCIAL_LINK);
  }

  logout() {
    this.props.logout.request();
  }

  renderAdminNavItem() {
    const { currentUserIsAdmin } = this.props;

    return currentUserIsAdmin && <AdminNavItems />;
  }

  renderUserNav() {
    const { currentUser, companies } = this.props;

    return (
      <Nav className="ml-3 mr-auto">
        {companies &&
          companies.length === 0 && (
            <NavItem className="my-auto pr-4">
              <RouterLink
                exact
                activeClassName={classnames(styles.active)}
                to={routeGenerator.users.bestProfile({ user: currentUser, isCurrentUser: true })}
              >
                <FormattedMessage id="app.layout.header.profile" defaultMessage="Profile" />
              </RouterLink>
            </NavItem>
          )}

        {companies.length > 0 && <Companies companies={companies} />}
      </Nav>
    );
  }

  renderAnonymousNav() {
    return (
      <Nav className={classnames('ml-auto text-center', styles.nav)}>
        {/* <NavItem className={classnames('my-auto px-4', styles.navItem)}>
          <RouterLink
            exact
            className={classnames('my-auto')}
            activeClassName={classnames(styles.active)}
            to={{ pathname: routeTemplates.aboutCompany, state: { ref: 'navbar' } }}
          >
            <FormattedMessage id="app.layout.header.about" defaultMessage="About Us" />
          </RouterLink>
        </NavItem> */}
        {/* {this.renderLinksNav()} */}
        {/* <NavItem className={classnames('mx-auto', styles.navItem)}>
          <RouterLink
            exact
            className={classnames(styles.navLink, 'my-auto')}
            activeClassName={classnames(styles.active)}
            to={routeTemplates.auth.login}
          >
            <FormattedMessage id="app.layout.header.log-in" defaultMessage="Login" />
          </RouterLink>
        </NavItem> */}
      </Nav>
    );
  }

  renderDropdownProfile() {
    const { currentUser, history, currentUserHasPassword, currentUserIsAdmin } = this.props;

    return (
      <Nav className="ml-auto">
        <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.sm}>
          {currentUser &&
            currentUser.myCompanies &&
            currentUser.myCompanies.length === 0 && (
              <div
                className={classnames(
                  styles.user,
                  'my-auto',
                  currentUser &&
                  currentUser.role !== 'admin' &&
                  currentUser.studentConfig &&
                  currentUser.studentConfig.accessEnds < Date.now() / 1000
                    ? styles.disabled
                    : null
                )}
              >
                <ThinkificSSO user={currentUser} />
              </div>
            )}
        </MediaQuery>

        <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.sm}>
          {this.renderAdminNavItem()}
        </MediaQuery>

        {!currentUserIsAdmin ? (
          currentUser.myCompanies && currentUser.myCompanies.length !== 0 ? (
            <div className={classnames(styles.companyadmin, 'my-auto')}>
              <FormattedMessage
                id="app.layout.header.companyadmin"
                defaultMessage="Hiring Manager"
              />
            </div>
          ) : null
        ) : null}
        <NavItem>
          <OverflowMenu
            renderIcon={iconProps => (
              <Avatar user={currentUser} size={33} className={classnames('text-center')} />
            )}
          >
            <OverflowMenuHeader
              className="py-3"
              onClick={
                currentUser.myCompanies && currentUser.myCompanies.length > 0
                  ? null
                  : () => history.push(`/${currentUser.username}`)
              }
            >
              {currentUser.name || currentUser.email}
            </OverflowMenuHeader>

            {currentUser &&
              currentUser.myCompanies &&
              currentUser.myCompanies.length === 0 && (
                <OverflowMenuHeader className="py-3" onClick={() => this.showBasicInfoModal()}>
                  Edit Information
                </OverflowMenuHeader>
              )}

            {currentUser &&
              currentUser.myCompanies &&
              currentUser.myCompanies.length === 0 && (
                <OverflowMenuHeader className="py-3" onClick={() => this.showSocialLinkModal()}>
                  Edit Social Links
                </OverflowMenuHeader>
              )}

            {currentUserHasPassword ? (
              <OverflowMenuItem
                className="py-3"
                onClick={() => history.push(routeTemplates.auth.changePassword)}
              >
                <FormattedMessage
                  id="app.layout.header.change-password"
                  defaultMessage="Change Password"
                />
              </OverflowMenuItem>
            ) : (
              <OverflowMenuItem
                className="py-3"
                onClick={() => history.push(routeTemplates.auth.setPassword)}
              >
                <FormattedMessage
                  id="app.layout.header.set-password"
                  defaultMessage="Set Password"
                />
              </OverflowMenuItem>
            )}
            <OverflowMenuBottom>
              <Button className="mt-2" isReady={false} onClick={this.logout}>
                <FormattedMessage id="app.layout.header.log-out" defaultMessage="Logout" />
              </Button>
            </OverflowMenuBottom>
          </OverflowMenu>
        </NavItem>
      </Nav>
    );
  }

  renderUserBurgerMenu() {
    const { currentUserIsAdmin, currentUser, companies } = this.props;

    return (
      <Nav>
        <NavItem className="my-auto">
          <Menu burger isOpenSubMenu={this.state.openSubMenu}>
            {currentUserIsAdmin && (
              <div data-subMenu>
                <FormattedMessage id="app.layout.header.admin" defaultMessage="Admin" />
                <ul>
                  <li className="text-left pl-4 py-4">
                    <Icon
                      background
                      name="icon--arrow-left"
                      tooltip="Previous"
                      description="previous"
                    />
                  </li>
                  <li className="pb-4">
                    <DropdownItem tag={RouterLink} to={routeTemplates.admin.users.index}>
                      <FormattedMessage id="app.layout.header.admin.users" defaultMessage="Users" />
                    </DropdownItem>
                  </li>
                  <li className="pb-4">
                    <DropdownItem tag={RouterLink} to={routeTemplates.admin.companies.root}>
                      <FormattedMessage
                        id="app.layout.header.admin.companies"
                        defaultMessage="Courses"
                      />
                    </DropdownItem>
                  </li>
                  <li className="pb-4">
                    <DropdownItem tag={RouterLink} to={routeTemplates.admin.profiler.root}>
                      <FormattedMessage
                        id="app.layout.header.admin.profiler"
                        defaultMessage="Entry Test"
                      />
                    </DropdownItem>
                  </li>
                </ul>
              </div>
            )}

            {companies.length === 0 && (
              <DropdownItem
                tag={RouterLink}
                to={routeGenerator.users.bestProfile({ user: currentUser })}
              >
                <FormattedMessage id="app.layout.header.profile.my" defaultMessage="Profile" />
              </DropdownItem>
            )}

            {/* {companies.length === 0 && (
              <DropdownItem
                tag={RouterLink}
                to={{ pathname: routeTemplates.validatorsLeaderboard, state: { ref: 'navbar' } }}
              >
                <FormattedMessage
                  id="app.layout.header.validatorsLeaderboard"
                  defaultMessage="Leaderboard"
                />
              </DropdownItem>
            )} */}
            {/*
              currentUser &&
              companies.length === 0 && (
                <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.sm}>
                  <DropdownItem
                    tag={RouterLink}
                    to={{ pathname: routeTemplates.validate, state: { ref: 'navbar' } }}
                    color="primary"
                  >
                    <FormattedMessage
                      id="app.layout.header.validate"
                      defaultMessage="Validate a Skill"
                    />
                  </DropdownItem>
                </MediaQuery>
              ) */}
            <DropdownItem>
              <Companies companies={companies} />
            </DropdownItem>
            {this.renderLinksDropdown()}
            <Button className="mt-2" onClick={this.logout}>
              <h3 className="m-0">
                <FormattedMessage id="app.layout.header.log-out" defaultMessage="Logout" />
              </h3>
            </Button>
          </Menu>
        </NavItem>
      </Nav>
    );
  }

  renderAnonymousBurgerMenu() {
    return (
      <Nav>
        <Menu burger>
          {this.renderLinksDropdown()}
          <DropdownItem tag={RouterLink} to={routeTemplates.auth.login}>
            <FormattedMessage id="app.layout.header.log-in" defaultMessage="Login" />
          </DropdownItem>
        </Menu>
      </Nav>
    );
  }

  renderLinksDropdown() {
    return (
      <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.sm}>
        <DropdownItem tag={RouterLink} to={{ pathname: routeTemplates.root }}>
          <FormattedMessage id="app.layout.header.home" defaultMessage="Home" />
        </DropdownItem>
        <DropdownItem tag={RouterLink} to={{ pathname: routeTemplates.aboutUs }}>
          <FormattedMessage id="app.layout.header.about" defaultMessage="About Us" />
        </DropdownItem>
        <DropdownItem tag={RouterLink} to={{ pathname: routeTemplates.faq }}>
          <FormattedMessage id="app.layout.header.faq" defaultMessage="FAQ" />
        </DropdownItem>
        <DropdownItem tag={RouterLink} to={{ pathname: routeTemplates.contactUs }}>
          <FormattedMessage id="app.layout.header.contact" defaultMessage="Contact Us" />
        </DropdownItem>
      </MediaQuery>
    );
  }

  renderLinksNav() {
    const { companies } = this.props;

    if (companies.length > 0)
      return <Nav className={classnames('ml-auto text-center', styles.nav)} />;
    return (
      <Nav className={classnames('ml-auto text-center', styles.nav)}>
        <NavItem className="my-auto pr-4">
          <RouterLink
            exact
            activeClassName={classnames(styles.active)}
            to={{ pathname: routeTemplates.root }}
          >
            <FormattedMessage id="app.layout.header.home" defaultMessage="Home" />
          </RouterLink>
        </NavItem>
        <NavItem className="my-auto pr-4">
          <RouterLink
            exact
            activeClassName={classnames(styles.active)}
            to={{ pathname: routeTemplates.aboutUs }}
          >
            <FormattedMessage id="app.layout.header.about" defaultMessage="About Us" />
          </RouterLink>
        </NavItem>
        <NavItem className="my-auto pr-4">
          <RouterLink
            exact
            activeClassName={classnames(styles.active)}
            to={{ pathname: routeTemplates.faq }}
          >
            <FormattedMessage id="app.layout.header.faq" defaultMessage="FAQ" />
          </RouterLink>
        </NavItem>
        <NavItem className="my-auto pr-4">
          <RouterLink
            exact
            activeClassName={classnames(styles.active)}
            to={{ pathname: routeTemplates.contactUs }}
          >
            <FormattedMessage id="app.layout.header.contact" defaultMessage="Contact Us" />
          </RouterLink>
        </NavItem>
      </Nav>
    );
  }

  render() {
    const { loggedIn, className, history, currentUser } = this.props;

    return (
      <Navbar
        id="main-header"
        tag="header"
        fixed="top"
        className={classnames(className, styles.navbar)}
      >
        <section
          ref={el => (this.navbar = el && el.parentElement)}
          className={classnames('container pr-md-0 page-max-width')}
        >
          <div
            className="pr-3"
            style={{ cursor: 'pointer' }}
            onClick={
              currentUser && currentUser.myCompanies && currentUser.myCompanies.length > 0
                ? null
                : () => history.push(routeTemplates.root)
            }
          >
            <img className={classnames(styles.logo)} src={tribePNG} alt="Tribe AcademyLogo" />
          </div>
          <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.sm}>
            {loggedIn ? this.renderUserNav() : this.renderAnonymousNav()}
          </MediaQuery>

          {loggedIn && this.renderDropdownProfile()}
          <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.sm}>
            {loggedIn ? this.renderUserBurgerMenu() : this.renderAnonymousBurgerMenu()}
          </MediaQuery>
        </section>
        <UpdateBasicInfo />
        <EditSocialLinks />
      </Navbar>
    );
  }
}

const myClaimsMatchSelector = createMatchSelector({ path: routeTemplates.claims.my, exact: true });
const claimsDetailsMatchSelector = createMatchSelector({
  path: routeTemplates.claims.details,
  exact: true,
});
const myVotesMatchSelector = createMatchSelector({ path: routeTemplates.votes.my, exact: true });

function mapStateToProps(state) {
  const myProfileRouteMatch = !!createMatchSelector({
    path: routeTemplates.users.myProfile,
    exact: true,
  })(state);
  const otherProfileRouteMatch = !!createMatchSelector({
    path: routeTemplates.users.vanityProfile,
    exact: true,
  })(state);
  const myClaimsMatch = myClaimsMatchSelector(state);
  const myVotesMatch = myVotesMatchSelector(state);
  const claimsDetailsMatch = claimsDetailsMatchSelector(state);
  const shouldMyClaimsBeActive =
    !!myClaimsMatch ||
    (claimsDetailsMatch &&
      claimsDetailsMatch.params &&
      claimsDetailsMatch.params.id &&
      selectIsCurrentUsersClaimById(state, { id: claimsDetailsMatch.params.id }));
  const shouldMyVotesBeActive =
    !shouldMyClaimsBeActive &&
    (!!myVotesMatch ||
      (claimsDetailsMatch &&
        claimsDetailsMatch.params &&
        claimsDetailsMatch.params.id &&
        selectCanCurrentUserVoteOnClaimById(state, { id: claimsDetailsMatch.params.id })));

  const canVisitNewClaimPage =
    AIPValidationEnabled &&
    (selectIsCurrentUserFullAccess(state) || selectIsCurrentUserAdmin(state));

  const canVisitValidationChoicePage = ImpressAIValidationEnabled;

  const showValidationButton = canVisitValidationChoicePage || canVisitNewClaimPage;
  const currentUserEthereumAddress = selectCurrentUserEthereumAddress(state);

  return {
    isCurrentUserTier3: selectIsCurrentUserTier3(state),
    loggedIn: selectIsLoggedIn(state),
    currentUser: selectCurrentUser(state),
    currentUserFetchedAtleastOnce: selectCurrentUserFetchedAtleastOnce(state),
    currentUserHasPassword: selectCurrentUserHasPassword(state),
    currentUserEthereumAddress,
    currentUserHasEthereumAddress: !!selectCurrentUserEthereumAddress(state),
    currentUserHasVerifiedEthereumAddress: selectIsCurrentUserEthereumAddressVerified(state),
    currentUserIsAdmin: selectIsCurrentUserAdmin(state),
    currentUserIsFullAccess: selectIsCurrentUserFullAccess(state),
    shouldMyClaimsBeActive,
    shouldMyVotesBeActive,
    currentUserIsNoAccess: selectIsCurrentUserNoAccess(state),
    canVisitValidationChoicePage,
    canVisitNewClaimPage,
    showValidationButton,
    myProfileRouteMatch,
    otherProfileRouteMatch,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: {
      request: bindActionCreators(logout.request, dispatch),
    },
    showModal: bindActionCreators(showModal, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: false /* This is required for link 'active' feature to work when route is changed. It works on refresh without this */,
})(injectIntl(withRouter(Header)));



// WEBPACK FOOTER //
// ./src/ui/app/layout/header/index.js